import React from 'react'

const Title = ({ title, style, children }) => (
  <span style={{ ...titleStyle, ...style }}>
    {title}
    {children}
  </span>
)

export default Title
const titleStyle = {
  fontWeight: 'bold',
  fontSize: '20px',
  margin: '1rem 0rem',
  lineHeight: 1.5,
  overflowWrap: 'normal',
}



// WEBPACK FOOTER //
// ./src/components/shared/title.js